<div class="white-box">
  <ng-container *ngIf="customer?.provider === 'email'; else showGoogleAlert">
    <form [formGroup]="formPass" novalidate>
      <p>{{ 'personal.note' | translate }}</p>
      <div class="input-box">
        <label>{{ 'personal.current_pass' | translate }}<br /></label>
        <div class="input-holder">
          <input
            [type]="showPass.currentPass ? 'text' : 'password'"
            minlength="6"
            autocomplete="off"
            maxlength="128"
            name="currentPassword"
            formControlName="currentPassword"
            [placeholder]="'personal.current_pass' | translate"
            class="password"
            [ngClass]="{ error: submitted && formPass.controls['currentPassword'].invalid }"
          />
          <span
            (click)="passVisibility('currentPass')"
            class="form-input-with-icon"
            [ngClass]="showPass.currentPass ? 'icon-i-visibility-on' : 'icon-i-visibility-off'"
          ></span>
        </div>
        <p class="empty error" *ngIf="submitted && formPass.controls['currentPassword'].invalid">
          {{ 'personal.error.need_current_pass' | translate }}
        </p>
      </div>
      <div class="input-box">
        <label>{{ 'personal.new_pass' | translate }}<br /></label>
        <div class="input-holder">
          <input
            (keyup)="checkMatch()"
            [type]="showPass.newPass ? 'text' : 'password'"
            minlength="6"
            maxlength="128"
            autocomplete="off"
            name="newPassword"
            formControlName="newPassword"
            [placeholder]="'personal.new_pass' | translate"
            class="password"
            [ngClass]="{ touched: formPass.get('newPassword').value }"
            required
          />
          <span
            (click)="passVisibility('newPass')"
            class="form-input-with-icon"
            [ngClass]="showPass.newPass ? 'icon-i-visibility-on' : 'icon-i-visibility-off'"
          ></span>
        </div>
        <app-register-password-strength
          [password]="formPass.get('newPassword').value"
          [controlTouched]="formPass.get('newPassword').touched"
          [dirty]="formPass.get('newPassword').dirty"
          [submitted]="submitted"
          (isPasswordInvalid)="onIsPasswordInvalid($event)"
        >
        </app-register-password-strength>
      </div>
      <div class="input-box">
        <label>{{ 'personal.rep_pass' | translate }}</label>
        <div class="input-holder">
          <input
            (keyup)="checkMatch()"
            [type]="showPass.newPassConf ? 'text' : 'password'"
            name="newPasswordConfirmation"
            autocomplete="off"
            formControlName="newPasswordConfirmation"
            [placeholder]="'personal.rep_pass' | translate"
            class="password"
            [ngClass]="{
              error: submitted && formPass.controls['newPasswordConfirmation'].invalid
            }"
          />
          <span
            (click)="passVisibility('newPassConf')"
            class="form-input-with-icon"
            [ngClass]="showPass.newPassConf ? 'icon-i-visibility-on' : 'icon-i-visibility-off'"
          ></span>
        </div>
        <p class="empty error" *ngIf="submitted && formPass.controls['newPasswordConfirmation'].invalid">
          {{ 'personal.error.need_conf_pass' | translate }}
        </p>
        <div *ngIf="!emptyConfirmationPwd && formPass.controls['newPasswordConfirmation'].valid">
          <p class="error">{{ issue | translate }}</p>
        </div>
      </div>
      <div>
        <button (click)="submit()" class="ui-button" [class.loading]="loading">
          <span class="icon-i-windmill"></span>
          {{ 'personal.reset_pass' | translate }}
        </button>
      </div>
    </form>
  </ng-container>
  <ng-template #showGoogleAlert>
    <div class="input-box google-provider-alert">
      <span class="icon-i-info"></span>
      <p [innerHTML]="'profile.personalDetails.gmailDisclaimer' | translate"></p>
    </div>
    <button routerLink="/help" class="ui-button fit-width">{{ 'contact.link' | translate }}</button>
  </ng-template>
</div>
